import { create } from 'zustand';
import { dashboardApi } from '../services/api';

interface TrendData {
  date: string;
  value: number;
}

interface DashboardStats {
  newUsersToday: number;
  activeUsersToday: number;
  runsToday: number;
  aiCallsToday: number;
  revenueToday: number;
  tokensToday: number;
  aiCostToday: number;
  avgCostPerUser: number;
  totalRunsToday: number;
  successRate: number;
  failureRate: number;
  avgExecutionTime: number;
  userTrend: TrendData[];
  runTrend: TrendData[];
  aiCostTrend: TrendData[];
  revenueTrend: TrendData[];
}

interface TopFailure {
  workflowFailures: Array<{
    workflowId: string;
    workflowName: string;
    failureCount: number;
    failureRate: number;
  }>;
  aiFailures: Array<{
    errorType: string;
    count: number;
  }>;
  webhookFailures: Array<{
    webhookId: string;
    failureCount: number;
  }>;
}

interface DashboardState {
  stats: DashboardStats | null;
  topFailures: TopFailure | null;
  isLoading: boolean;
  error: string | null;
  
  fetchStats: () => Promise<void>;
  fetchTopFailures: () => Promise<void>;
  clearError: () => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  stats: null,
  topFailures: null,
  isLoading: false,
  error: null,

  fetchStats: async () => {
    set({ isLoading: true, error: null });
    try {
      const response = await dashboardApi.getStats();
      if (response.code === 0) {
        set({ stats: response.data });
      } else {
        set({ error: response.message });
      }
    } catch (err) {
      set({ error: err instanceof Error ? err.message : 'Failed to fetch stats' });
    } finally {
      set({ isLoading: false });
    }
  },

  fetchTopFailures: async () => {
    try {
      const response = await dashboardApi.getTopFailures();
      if (response.code === 0) {
        set({ topFailures: response.data });
      }
    } catch (err) {
      console.error('Failed to fetch top failures:', err);
    }
  },

  clearError: () => set({ error: null }),
}));
